var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrrorImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 201,
    viewBox: "0 0 201 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.034 25.4655C98.1538 25.7209 84.9921 33.026 76.7436 44.1838C69.6401 53.7928 58.5831 59.7956 46.6339 59.7893C46.2831 59.7889 45.9319 59.7928 45.5792 59.8006C21.3933 60.3296 0.826852 81.0811 0.504196 105.271C0.160837 131.025 20.9347 152.01 46.6104 152.01C66.5116 152.01 83.4655 139.402 89.9249 121.738C91.6155 117.116 96.6253 114.639 101.364 115.968C101.423 115.985 101.482 116.001 101.541 116.017C105.877 117.214 108.751 121.346 108.396 125.83C107.921 131.839 108.624 138.039 110.662 144.109C118.678 167.99 144.719 181.095 168.667 173.281C193.164 165.287 206.315 138.834 198.01 114.53C193.39 101.011 183.112 91.0303 170.725 86.326C164.307 83.8889 160.042 77.7885 159.948 70.9245C159.946 70.7745 159.943 70.6241 159.94 70.4733C159.358 45.5124 138.705 25.4596 113.83 25.4585C113.565 25.4585 113.301 25.4608 113.034 25.4655Z",
    fill: "url(#paint0_linear_5520_217253)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5520_217253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 201
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.500015H200.5V200.5H0.5V0.500015Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5520_217253)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5520_217253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 15,
    width: 157,
    height: 66
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.375 15.457H178.625V80.082H22.375V15.457Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5520_217253)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.100006
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.625 80.082V43.7621C178.625 40.5281 176 37.9027 172.766 37.9027H116.074L103.857 17.3664C102.343 14.8207 98.657 14.8207 97.143 17.3664L84.9266 37.9027H28.2344C25 37.9027 22.375 40.5281 22.375 43.7621V80.082H178.625Z",
    fill: "#005B99"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.653 185.542H78.3477L87.2078 150.423H113.793L122.653 185.542Z",
    fill: "#8AB4D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.877 162.65H84.1211L87.2066 150.423H113.792L116.877 162.65Z",
    fill: "#005B99"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.625 51.9668V151.283C178.625 154.518 176 157.143 172.766 157.143H28.2344C25 157.143 22.375 154.518 22.375 151.283V51.9668C22.375 48.7324 25 46.1074 28.2344 46.1074H172.766C176 46.1074 178.625 48.7324 178.625 51.9668Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6349 113.849H146.366C149.396 113.849 151.272 110.549 149.723 107.946L103.858 30.8428C102.343 28.2971 98.6576 28.2971 97.1435 30.8428L51.2779 107.946C49.7287 110.549 51.6052 113.849 54.6349 113.849Z",
    fill: "#E6EFF5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178.625 81.2529V51.9658C178.625 48.7314 176 46.1064 172.766 46.1064H28.2344C25 46.1064 22.375 48.7314 22.375 51.9658V81.2529H178.625Z",
    fill: "#FFEDEF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M178.625 64.9238V51.9664C178.625 48.7301 176.002 46.107 172.766 46.107H28.2344C24.9984 46.107 22.375 48.7301 22.375 51.9664V64.9238H178.625Z",
    fill: "#337CAD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.375 64.9238H178.625",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1066 174.606L87.2074 150.423H113.793L122.652 185.542H78.3477",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.375 137.458V151.282C22.375 154.518 24.9984 157.142 28.2344 157.142H172.766C176.002 157.142 178.625 154.518 178.625 151.282V137.458H22.375Z",
    fill: "#8AB4D0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M178.409 137.457H22.375",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8398 185.54H130.163",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.25 55.4866V55.5439",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8008 55.4866V55.5439",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3477 55.4866V55.5439",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4844 46.1066H28.2344C24.9984 46.1066 22.375 48.7297 22.375 51.966V151.281C22.375 154.517 24.9984 157.141 28.2344 157.141H172.766C176.002 157.141 178.625 154.517 178.625 151.281V51.966C178.625 48.7297 176.002 46.1066 172.766 46.1066H126.81",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6349 108.575H146.366C149.396 108.575 151.272 105.276 149.723 102.672L103.858 25.5693C102.343 23.0236 98.6576 23.0236 97.1435 25.5693L51.2779 102.672C49.7287 105.276 51.6052 108.575 54.6349 108.575Z",
    fill: "#F06677"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6349 108.575H146.366C149.396 108.575 151.272 105.276 149.723 102.672L103.858 25.5693C102.343 23.0236 98.6576 23.0236 97.1435 25.5693L51.2779 102.672C49.7287 105.276 51.6052 108.575 54.6349 108.575Z",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 82.4785C98.343 82.4785 96.5938 80.7297 96.5938 78.5723V52.8887C96.5938 50.7316 98.343 48.9824 100.5 48.9824C102.657 48.9824 104.406 50.7316 104.406 52.8887V78.5723C104.406 80.7297 102.657 82.4785 100.5 82.4785Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 94.6104C98.343 94.6104 96.5938 92.8615 96.5938 90.7041V90.6592C96.5938 88.5018 98.343 86.7529 100.5 86.7529C102.657 86.7529 104.406 88.5018 104.406 90.6592V90.7041C104.406 92.8615 102.657 94.6104 100.5 94.6104Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5883 118.61C46.9105 120.288 44.1898 120.288 42.5117 118.61C44.1898 120.288 44.1898 123.008 42.5117 124.687C44.1898 123.008 46.9102 123.008 48.5883 124.687C46.9102 123.008 46.9105 120.288 48.5883 118.61Z",
    stroke: "#F06677",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4715 118.61C62.7934 120.288 60.0727 120.288 58.3945 118.61C60.0727 120.288 60.0727 123.008 58.3945 124.687C60.0727 123.008 62.7934 123.008 64.4715 124.687C62.7934 123.008 62.7934 120.288 64.4715 118.61Z",
    stroke: "#F06677",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3582 118.61C78.6801 120.288 75.9594 120.288 74.2812 118.61C75.9594 120.288 75.9594 123.008 74.2812 124.687C75.9594 123.008 78.6801 123.008 80.3582 124.687C78.6801 123.008 78.6801 120.288 80.3582 118.61Z",
    stroke: "#F06677",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M156.532 119.91H95.1441C94.0633 119.91 93.1875 119.034 93.1875 117.954C93.1875 116.873 94.0633 115.997 95.1441 115.997H156.532C157.613 115.997 158.489 116.873 158.489 117.954C158.489 119.034 157.613 119.91 156.532 119.91Z",
    fill: "#E6EFF5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M156.532 127.298H95.1441C94.0633 127.298 93.1875 126.422 93.1875 125.342C93.1875 124.261 94.0633 123.385 95.1441 123.385H156.532C157.613 123.385 158.489 124.261 158.489 125.342C158.489 126.422 157.613 127.298 156.532 127.298Z",
    fill: "#E6EFF5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6516 176.591L52.3477 172.287L56.6516 167.983L60.9559 172.287L56.6516 176.591Z",
    stroke: "#F599A4",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M125.839 31.3652L121.535 27.0613L125.839 22.7574L130.143 27.0613L125.839 31.3652Z",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M143.07 15.4566C143.07 17.8336 141.143 19.7605 138.766 19.7605C141.143 19.7605 143.07 21.6875 143.07 24.0645C143.07 21.6875 144.997 19.7605 147.374 19.7605C144.997 19.7605 143.07 17.8336 143.07 15.4566Z",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4719 22.7574C64.4719 25.1344 62.5449 27.0613 60.168 27.0613C62.5449 27.0613 64.4719 28.9883 64.4719 31.3652C64.4719 28.9883 66.3988 27.0613 68.7762 27.0613C66.3988 27.0613 64.4719 25.1344 64.4719 22.7574Z",
    stroke: "#8AB4D0",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5520_217253",
    x1: 196.333,
    y1: 165.93,
    x2: 11.9194,
    y2: 211.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#337CAD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AB4D0",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrrorImage);
export default __webpack_public_path__ + "static/media/errror-image.1a628d1222d4a0f24e299ce53a903788.svg";
export { ForwardRef as ReactComponent };